import CompleteTransaction from '../complete-transaction';
import Paybar from './pay-bar';
import PaymentButtons from './payment-buttons';

import styles from './index.module.scss';
// import Receipt from '../receipt';
import { useGetCart } from '../../../integrations/react_query/queries';
import { ECart, EQuerykeys } from '../../../models';
import { useCartAnalytics } from '../../../hooks/useCartAnalytics';
import { getSessionInfo } from '../../../utils/getSessionInfo';
import { useMutation } from 'react-query';
import ThermalUsbPrinter from '../../../lib/printer';
import { Tracking } from '../../../analytics/tracking';
import { EVENTS } from '../../../utils/events/index';

export const PaymentOptions = () => {
	const thermalPrinter = new ThermalUsbPrinter();

	const { data } = useGetCart([EQuerykeys.cart, ECart.active]);

	const { payableAmount, vatAmount, totalSavings, cartSumWithoutDiscount } = useCartAnalytics(data?.products ?? []);

	//TODO: put this in cart analytics
	const totalSumOfAmountPaid = (data?.payments || [])?.reduce((acc: any, p: any) => acc + +p?.amountPaid, 0);

	const { userInfo } = getSessionInfo();

	const { mutateAsync: print, isLoading: isPrinting } = useMutation({
		mutationFn: async () => {
			if (!data) return;

			thermalPrinter.printReceipt({
				data,
				userInfo,
				cartSumWithoutDiscount: cartSumWithoutDiscount,
				totalSavings: totalSavings,
				totalSumOfAmountPaid: totalSumOfAmountPaid,
				vatAmount,
			});
		},
		onSuccess: () => {
			Tracking.capture(EVENTS.SALES.PRINT_SUCCESS, {
				transactionId: data?.transactionId,
				userId: userInfo?._id,
			});
		},
		onError: (err: any) => {
			Tracking.capture(EVENTS.SALES.PRINT_FAILED, {
				transactionId: data?.transactionId,
				userId: userInfo?._id,
				errorMessage: err ?? 'Unknown error',
			});
		},
	});

	if (!data) return null;

	return (
		<section
			className={`${styles.wrapper} w-full h-[calc(100vh_-_120px)] md:h-[calc(100vh_-_80px)] relative hidden md:block col-span-12 md:col-span-7 overflow-y-auto`}
		>
			{!!data?.transactionId ? (
				<>
					<CompleteTransaction
						data={data}
						totalAmount={+payableAmount}
						totalPayment={totalSumOfAmountPaid}
						handlePrintReceipt={() => print()}
						isPrinting={isPrinting}
					/>

					{/* <Receipt {...{ data: cartData }} /> */}
				</>
			) : (
				<>
					<Paybar />
					<PaymentButtons />
				</>
			)}
		</section>
	);
};

export default PaymentOptions;
